/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLineAccountLinkOneTimePassword201Response
 */
export interface PostLineAccountLinkOneTimePassword201Response {
    /**
     * 
     * @type {string}
     * @memberof PostLineAccountLinkOneTimePassword201Response
     */
    oneTimePassword: string;
}

/**
 * Check if a given object implements the PostLineAccountLinkOneTimePassword201Response interface.
 */
export function instanceOfPostLineAccountLinkOneTimePassword201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "oneTimePassword" in value;

    return isInstance;
}

export function PostLineAccountLinkOneTimePassword201ResponseFromJSON(json: any): PostLineAccountLinkOneTimePassword201Response {
    return PostLineAccountLinkOneTimePassword201ResponseFromJSONTyped(json, false);
}

export function PostLineAccountLinkOneTimePassword201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLineAccountLinkOneTimePassword201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oneTimePassword': json['oneTimePassword'],
    };
}

export function PostLineAccountLinkOneTimePassword201ResponseToJSON(value?: PostLineAccountLinkOneTimePassword201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'oneTimePassword': value.oneTimePassword,
    };
}

